import React from 'react'
import { FormContextProvider } from '../../../../../context/formContext'
// import Toast from '../../../../../components/Toast/Toast'
import ViewFormsElegibilidad from './ViewFormsElegibilidad'

const FormsDraftWrapperElegibilidad = () => {
  return (
    // TODO: Quitar contexto de Pre-Elegibilidad
    <FormContextProvider>
      {/* <Toast /> */}
      <ViewFormsElegibilidad />
    </FormContextProvider>
  )
}

export default FormsDraftWrapperElegibilidad
